import request from 'sb-request'
import { reducers } from 'redux/core'

import dropdownMenuOptionsQuery from './dropdownMenuOptions.graphql'


const fetch = (gender) => {
  if (!gender) {
    throw new Error('gender is empty')
  }

  reducers.view.navigation.setFetching(true)

  return request.post('graphql?name=dropdownMenuOptions', {
    body: {
      query: dropdownMenuOptionsQuery,
      variables : { gender },
    },
    modifyResult: ({ dropdownMenuOptions }) => (dropdownMenuOptions),
  }).then((navigation) => {
    reducers.view.navigation.update({
      ...navigation,
      isFetching: false,
      isFetched: true,
    })
  })
}


export default {
  fetch,
}
